import { fullAnimate } from '@/components/Modal'
import { devicesDataState } from '@/store/deviceInfo'
import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { stepAnimate } from '..'
import mikeupImg from '../images/content-mike-up.png'
import contentmikeImg from '../images/content-mike.png'
import contentmike1Img from '../images/content-mike1.png'
import contentmike2Img from '../images/content-mike2.png'
import contentmike3Img from '../images/content-mike3.png'
import contentmike4Img from '../images/content-mike4.png'

interface IProps {
  rtcEngine: any
  next: (stepActive: number, status?: boolean) => void
}

let intervalTimer: string | number | NodeJS.Timeout | undefined = undefined
let timeoutTimer: string | number | NodeJS.Timeout | undefined = undefined
export default ({ rtcEngine, next }: IProps) => {
  const devicesData = useRecoilValue(devicesDataState)
  const [isBtn, setisBtn] = useState<boolean>(true)
  const [volume, setvolume] = useState<number>(0)
  const [timer, settimer] = useState<number>(6)
  const [volumeNum, setvolumeNum] = useState<number>(0)
  const maxVolume = useRef<number>(0)
  const success = useRef<boolean>(false)

  useEffect(() => {
    // TODO 需要大改
    rtcEngine.getVolume()
    const audioInputList = devicesData?.audioInputDevices
    if (audioInputList?.length > 0) {
      try {
        rtcEngine.on('eventDevicesVolu', speakeFn)
      } catch (err) {
        console.log(err)
      }
    }
    // TODO 需要大改
    timeoutTimer = setTimeout(() => {
      startTimer()
    }, 4000)

    return () => {
      console.log('------销毁-----')
      rtcEngine.off('eventDevicesVolu', speakeFn)
      clearInterval(intervalTimer)
      clearTimeout(timeoutTimer)
    }
  }, [])

  useEffect(() => {
    computVolume(volume)
  }, [volume])

  useEffect(() => {
    if (volume > 15) {
      success.current = true
      next(2, success.current)
    }
    if (timer <= 0) {
      if (success.current) {
        console.log('声音检测通过', maxVolume.current)
      } else {
        console.log('声音检测未通过', maxVolume.current)
      }
      next(2, success.current)
    }
  }, [volume, timer])

  const handleAsk = () => {
    setisBtn((v) => !v)
  }
  const speakeFn = (v: number) => {
    if (v > maxVolume.current) {
      maxVolume.current = v
    }
    setvolume(v)
  }
  const startTimer = () => {
    intervalTimer = setInterval(() => {
      settimer((v) => (v -= 1))
    }, 1000)
  }
  const computVolume = (val: number) => {
    const volumeArr = [
      [0, 15], /// [0, 25],
      [15, 35], /// [25, 50],
      [35, 60], /// [50, 75],
      [60, 100] /// [75, 100]
    ]
    volumeArr.forEach((item, index) => {
      if (item[0] < val && val <= item[1]) {
        setvolumeNum(index + 1)
      }
    })
  }

  return (
    <Container {...stepAnimate} className="alls-testing">
      <div className="base-img">
        <div className={`base-img-up${volumeNum}`} />
      </div>
      <div className="timer">
        {timer !== 6 ? (
          <div>
            录音时间：
            <span className="second">{timer}s</span>
          </div>
        ) : null}
      </div>
      {isBtn ? (
        <div className="title">
          请对着麦克风说：“
          <span className="title-text">美术宝学生端，用画画认识世界</span>”
        </div>
      ) : null}
      {isBtn ? (
        <div className="btns">
          <div className="btn-ask hover:scale-105 hover:cursor-pointer active:scale-95 transition" onClick={handleAsk}>
            ?
          </div>
        </div>
      ) : null}
      <AnimatePresence>
        {!isBtn ? (
          <motion.div {...fullAnimate} className="ask">
            <div>
              <div>如果你看不到麦克风波动，请按以下方式排查问题：</div>
              <div>1.请检查是否插入麦克风设备</div>
              <div>2.请对着麦克风说话</div>
              <div>3.打开社交软件测试麦克风是否可用（如：QQ，微信等）</div>
            </div>
            <div className="yes-ask hover:scale-105 hover:cursor-pointer active:scale-95 transition" onClick={handleAsk}>
              知道了
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </Container>
  )
}

const Container = styled(motion.div)`
  .base-img {
    background-image: url('${contentmikeImg}');
    position: relative;
    &-color {
      width: 85px;
      height: 0;
      background: #ff871a;
      position: absolute;
      right: 45px;
      bottom: 44px;
      z-index: 1;
    }
    &-up,
    &-up1,
    &-up2,
    &-up3,
    &-up4 {
      background-image: url('${mikeupImg}');
      width: 100%;
      height: 100%;
      background-position: 0 0;
      background-size: 100% 100%;
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
    }
    &-up1 {
      background-image: url('${contentmike1Img}');
    }
    &-up2 {
      background-image: url('${contentmike2Img}');
    }
    &-up3 {
      background-image: url('${contentmike3Img}');
    }
    &-up4 {
      background-image: url('${contentmike4Img}');
    }
  }
  .timer {
    margin: 25px 0 5px 0;
    height: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    .second {
      color: #ff7800;
      font-size: 18px;
    }
  }
  .btns {
    width: 100%;
    position: relative;
    height: 45px;
    display: flex;
    justify-content: center;
    // justify-content: space-between;
  }
  .title {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    margin: 10px 0 10px 0;
    &-text {
      font-size: 14px;
      color: #333333;
    }
  }
  .ask {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    line-height: 20px;
    font-size: 14px;
    // width: 750px;
    height: 130px;
    background: rgba(255, 241, 229, 1);
    border-radius: 0px 0px 12px 12px;
    display: flex;
    justify-content: space-between;
    // align-items: flex-end;
    padding: 30px 25px;
    box-sizing: border-box;
    color: rgba(255, 120, 0, 1);
    // line-height: 16px;
    box-shadow: 0 4px 8px 4px #dcdcdc;
  }
  .yes-ask {
    text-decoration: underline;
  }
  .btn-ask {
    width: 45px;
    height: 45px;
    background: rgba(255, 120, 0, 0.1);
    border-radius: 28px;
    font-size: 25px;
    font-weight: 500;
    color: rgba(255, 120, 0, 1);
    text-align: center;
    line-height: 45px;
    position: absolute;
    left: -40px;
  }
  .yes {
    // background: linear-gradient(180deg, rgba(14, 198, 69, 1) 0%, rgba(16, 214, 75, 1) 100%);
    // box-shadow: 0px 3px 0px 0px rgba(13, 158, 56, 1);
    background: #0bc442;
    box-shadow: 0px 4px 0px 0px #0d9e38;
  }
  .no {
    // background: linear-gradient(180deg, rgba(243, 8, 8, 1) 0%, rgba(255, 65, 65, 1) 100%);
    // box-shadow: 0px 3px 0px 0px rgba(207, 11, 11, 1);
    background: #ff5050;
    box-shadow: 0px 3px 0px 0px #d1385f;
  }
`
